import { useEffect, useState } from "react";

const SECOND_MS = 1000;
const MINUTE_MS = 60 * SECOND_MS;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

function splitRemaining(targetMs) {
  const remaining = Math.max(0, targetMs - Date.now());
  return {
    days: Math.floor(remaining / DAY_MS),
    hours: Math.floor((remaining % DAY_MS) / HOUR_MS),
    minutes: Math.floor((remaining % HOUR_MS) / MINUTE_MS),
    seconds: Math.floor((remaining % MINUTE_MS) / SECOND_MS),
    isExpired: remaining === 0,
  };
}

/**
 * Time left until `targetMs` (epoch ms), refreshed every second.
 * Each tick recomputes from the clock instead of decrementing, so the value is
 * right again as soon as a throttled background tab wakes up.
 * Client-only: the value depends on the current time, so it must not be SSR'd.
 */
export default function useCountdown(targetMs) {
  const [remaining, setRemaining] = useState(() => splitRemaining(targetMs));

  useEffect(() => {
    setRemaining(splitRemaining(targetMs));
    if (targetMs <= Date.now()) return undefined;

    const timer = setInterval(() => {
      const next = splitRemaining(targetMs);
      setRemaining(next);
      if (next.isExpired) clearInterval(timer);
    }, SECOND_MS);
    return () => clearInterval(timer);
  }, [targetMs]);

  return remaining;
}
